module.exports = __webpack_public_path__ + "img/contact-people.52b043f3.png";